import styled, { css } from 'styled-components';
import { renderTextVariations } from '../utils/renderTextVariations.js';
import { wrapContentWithSeparator } from '../utils/wrapContentWithSeparator.js';

const ParagraphLg = styled.p(({ type = 'default', bold, separator, stylish, theme: { olist: { components: { text: { paragraphLg }, }, }, }, }) => css `
      ${renderTextVariations(paragraphLg, type, bold, stylish)}
      ${separator && wrapContentWithSeparator()}
    `);

export { ParagraphLg as default };
